import React from 'react'
import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import ConnectAnalytics from '../components/connect-analytics'

export default function ConnectToGoogleAnalytics(): React.ReactElement {
  return (
    <SiteWrapper skeleton justLogo>
      <Layout width={1200}>
        <ConnectAnalytics />
      </Layout>
    </SiteWrapper>
  )
}
